<template>
  <div>
    <sf-bottom-modal :isOpen="visable" transition="sf-fade" class="bottomCookie">
      <div class="flex justify-center items-center">
        <div class="text-sm">
          <div class="font-semibold text-xl">{{ $t('BootomCookieTitle') }}</div>
          {{ $t('BootomCookieContext') }} <SfButton class="sf-button--text" @click="openModalXieYi">{{
            $t('BootomCookieLink') }}</SfButton>
        </div>
        <div class="ml-10">
          <SfButton class="p-2 px-4 text-xs" @click="clickAuthCookie">{{
            $t('colseCookie')
            }}</SfButton>
        </div>
      </div>
      <template #close-desktop>
        <SfIcon @click="closeModal" icon="cross" size="xxs" color="#d1d5db" viewBox="0 0 24 24" :coverage="1"
          class="absolute top-4 right-6" />
      </template>
    </sf-bottom-modal>
    <Modal ref="registerComponent" name="cookie" />
  </div>
</template>
<script>
import { SfBottomModal, SfLink, SfIcon, SfButton, SfModal } from '@storefront-ui/vue';
import { ref, onMounted } from '@nuxtjs/composition-api';
import Modal from '@/components/ContentModal/modal';
export default {
  components: {
    SfBottomModal,
    SfLink,
    SfIcon,
    SfButton,
    SfModal,
    Modal
  },
  setup(prop, { root: { context: { $cookies } }, root }) {
    const visable = ref(false);
    onMounted(() => {
      const isAuth = $cookies.get('IS_AUTHED_COOKIE');
      if (isAuth) {
        visable.value = false;
      } else {
        visable.value = true;
      }
    });
    const closeModal = () => {
      visable.value = false;
    };
    const clickAuthCookie = () => {
      closeModal();
      $cookies.set('IS_AUTHED_COOKIE', true, {
        path: '/',
        maxAge: 60 * 60 * 24 * 30 * 24,
        sameSite: 'lax'
      });
    };
    const registerComponent = ref();
    const openModalXieYi = () => {
      registerComponent.value.openModalXieYi();
    }
    return {
      visable,
      clickAuthCookie,
      closeModal,
      registerComponent,
      openModalXieYi
    };
  }
};
</script>
<style lang="scss" scoped>
.text-sm{
  color:#000;
  .font-semibold{
    color:#000;
  }
  a{
    color:#000;
  }
}
.bottomCookie {
  z-index: 999999999;
  ::v-deep .sf-overlay {
    background: #fff;
    display: none !important;
  }
  @media screen and (max-width: 768px) {
    ::v-deep .sf-bottom-modal__container {
      border-top: 1px solid #d4d8df;
      position: relative;
      padding:1rem;
      padding-bottom:0;
      .ml-10{
        padding-bottom:1rem;
      }
    }
  }
  ::v-deep .sf-bottom-modal__container {
    border-top: 1px solid #d4d8df;
    position: relative;
  }
}
.sf-modal__container{
 min-height: 10rem;
  .context {
    min-height: 5rem;
  }
}

</style>
